import React from 'react'
import {Typography,AppBar} from '@material-ui/core'
import VideoPlayer from './components/VideoPlayer'
import Notifications from './components/Notifications'
import Options from "./components/Options"
import "./App.css"
import {makeStyles} from '@material-ui/core/styles'


const useStyles = makeStyles((theme)=>({
    appBar:{
        borderRadius:15,
        margin:'30px 100px',
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        alignItems:'center',
        width:'600px',
        border:'1px solid rgba(0,0,0,0.2)',
        [theme.breakpoints.down('xs')]:{
            width:'90%',
        },
    },
    wrapper:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        width:'100%',
    },
}));

const App = () => {
    const classes =useStyles();
    return (<>
        <div className={classes.wrapper}>
        <AppBar className={classes.appBar} position="static" color="inherit">
            <Typography variant="h3" align="center" style={{color:'#9323EB',fontFamily: 'Righteous',fontWeight:'400'}}>meeton</Typography>
        </AppBar>
        <VideoPlayer/>
        <Options>
            <Notifications />
        </Options>
        <p><b>Made <span id="heart">❤</span> with ERTOS PROJECT</b><br/>
    
        <span id="creator">Created by Manish, ShivRanjan, Aadesh & Mayur</span></p>
        </div>
        
        </>
    )
}
export default App;
